export default "assets/logo-9fb610e9.png";